import { useRouter } from 'next/router';
import {
  Legend,
  RadialBar,
  RadialBarChart,
  ResponsiveContainer,
  Tooltip
} from 'recharts';
import { getTranslatedText } from 'services/multilingual.service';
import { StyledRecharts } from './Recharts.styled';

const MostOfferedPerks: React.FC = () => {
  const { locale } = useRouter();

  const data = [
    {
      name: {
        EN: 'Teambuilding events and dynamics',
        ES: 'Dinámicas y eventos de teambuilding'
      },
      value: 53.23275862068966,
      fill: '#E7278A'
    },
    {
      name: { EN: 'Budget for training', ES: 'Presupuesto para formación' },
      value: 51.939655172413794,
      fill: '#E3A702'
    },
    {
      name: {
        EN: 'Internal training events',
        ES: 'Eventos de formación internos'
      },
      value: 44.396551724137936,
      fill: '#E41B1E'
    },
    {
      name: { EN: 'Private health insurance', ES: 'Seguro de salud' },
      value: 36.206896551724135,
      fill: '#65A41E'
    },
    {
      name: {
        EN: 'Budget for conferences',
        ES: 'Presupuesto para Conferencias'
      },
      value: 31.896551724137932,
      fill: '#A6761D'
    },
    {
      name: { EN: 'Language classes', ES: 'Clases de Idiomas' },
      value: 31.68103448275862,
      fill: '#D95F02'
    },
    {
      name: {
        EN: 'Possibility to choose your devices',
        ES: 'Posibilidad de elegir equipo'
      },
      value: 29.95689655172414,
      fill: '#1B9D76'
    },
    {
      name: { EN: 'Extra days of annual leave', ES: 'Vacaciones Extra' },
      value: 29.310344827586203,
      fill: '#746FB3'
    },
    {
      name: { EN: 'Free coffee, fruit and snacks', ES: 'Café, fruta y snacks' },
      value: 22.198275862068968,
      fill: '#1E77B3'
    }
  ].map(({ name, value, fill }) => ({
    name: getTranslatedText(name, locale),
    value,
    fill
  }));

  return (
    <div>
      <StyledRecharts className="radial">
        <ResponsiveContainer height={550}>
          <RadialBarChart
            innerRadius="10%"
            outerRadius="80%"
            data={data}
            startAngle={180}
            endAngle={0}
          >
            <RadialBar background dataKey="value" />
            <Legend
              iconType="square"
              layout="horizontal"
              verticalAlign="bottom"
              align="center"
            />
            <Tooltip
              cursor={{ stroke: 'rgba(255, 255, 255, .5)' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-y"
            />
          </RadialBarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default MostOfferedPerks;
